/* eslint-disable @next/next/no-img-element */
import { Hr_Runner } from "@/graphql/gql/graphql";
import { colorWhite } from "../../../styles/manualVars";
import styles from "./tableCells.module.scss";

interface SilkNumProps {
  runner: Hr_Runner;
  saddleColor: string | undefined;
  numberColor: string | undefined;
}

const SilkNum = ({ runner, saddleColor, numberColor }: SilkNumProps) => (
  <div className={styles.silkContainer}>
    <div
      style={{ backgroundColor: saddleColor, color: numberColor ?? colorWhite }}
    >
      {runner.runnerId}
    </div>
    {runner.timeform?.silkUrlSvg ? (
      <img
        width={40}
        height={40}
        alt={`${runner?.horseName} silk`}
        src={runner.timeform?.silkUrlSvg}
      />
    ) : (
      ""
    )}
  </div>
);

export default SilkNum;
